module.exports = __webpack_public_path__ + "static/media/1-min.a03c7359.png";